import { Wallet, Truck, BarChart3, FileText, ChevronRight } from "lucide-react";
import "./more.css";
import Template from "../Template";
import { useNavigate } from "react-router-dom";
import { uiAlert } from "../../components/alerts/customAlert/uiAlert";

// Self-contained page (not an overlay) — drop it into a route/tab.
//
// onNavigate(routeKey) is called when a row is tapped, with one of:
//   "payouts" | "logistics" | "analytics" | "tax"
// Wire it to however your app already handles navigation (React Router,
// a tab-state setter, etc.) — this component doesn't assume a router.

const MORE_ROUTES = [
  {
    key: "payouts",
    label: "Payouts",
    description: "Check payouts from online purchases",
    icon: Wallet,
  },
  {
    key: "logistics",
    label: "Logistics & Delivery",
    description: "Find delivery options for orders",
    icon: Truck,
  },
  {
    key: "analytics",
    label: "Analytics & Reports",
    description: "Sales insights and business reports",
    icon: BarChart3,
  },
  {
    key: "tax",
    label: "Tax",
    description: "Generate VAT and income tax statements",
    icon: FileText,
  },
];

export const MorePage = ({ onNavigate = () => {} }) => {
  const navigate = useNavigate();

  return (
    <Template>
      <div className='sl-more'>
        <div className='sl-more-header'>
          <h2>More</h2>
          <p>Manage payouts, delivery, reports and tax</p>
        </div>

        <div className='sl-more-list'>
          {MORE_ROUTES.map(({ key, label, description, icon: Icon }) => (
            <button
              key={key}
              className='sl-more-row'
              onClick={() => {
                if (key !== "analytics") {
                  uiAlert("This page is currently not avaiable, contact support for more info");
                  return;
                }

                navigate(`/more/${key}`);
              }}
            >
              <span className='sl-more-row-icon'>
                <Icon size={18} />
              </span>
              <span className='sl-more-row-text'>
                <span className='sl-more-row-label'>{label}</span>
                <span className='sl-more-row-description'>{description}</span>
              </span>
              <ChevronRight size={17} className='sl-more-row-chevron' />
            </button>
          ))}
        </div>
      </div>
    </Template>
  );
};
